import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useSettings, useSingleSettings } from '@/data/Settings';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { transactionsValesDeCaja } from 'integration/generated/transactions';
import { RequestParams } from 'integration/generated/transactions/http-client';
import { useMemo } from 'react';
import useSWR from 'swr';
import getValueByPathFromUnknown from 'integration/utils/getValueByPathFromUnknown';

type GenericQuery = Record<string, unknown>;

const findValesDeCajaFetcher =
	(pub: boolean) =>
	async (storeId: string, query: GenericQuery = {}, params: RequestParams) => {
		const res = await transactionsValesDeCaja(pub).findValesDeCaja(storeId, query, params);
		return res;
	};

const DATA_KEY_VALES_DE_CAJA = 'valesDeCaja';

export const useValesDeCaja = (args: { orderId?: string; enabled: boolean }) => {
	const { settings } = useSettings();
	const router = useNextRouter();
	const { storeId } = getClientSideCommon(settings, router);
	const params = useExtraRequestParameters();
	const { settings: singleSettings } = useSingleSettings();

	const enabledMonederoDpt = useMemo(() => {
		const userData = singleSettings?.userData || {};
		const env = getValueByPathFromUnknown(userData, ['active_monederoDpt']) || null;
		return env === 'true' || env === '1' || env === 1 || env === true;
	}, [singleSettings?.userData]);

	const query = useSWR(
		storeId && args.enabled && enabledMonederoDpt
			? [{ storeId, orderId: args?.orderId }, DATA_KEY_VALES_DE_CAJA]
			: null,
		async ([{ storeId, orderId }]) => findValesDeCajaFetcher(true)(storeId, { orderId }, params)
	);

	return query;
};
